import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Elixhauser from './Elixhauser';
import Basic from './Basic';
import Intake from './Intake';
import Monthly from './Monthly';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';

import { API_STATUS, BASE_URL } from '../../constants';
import Otherjoints from './OtherJoints';
import InnerHTMLTable from './formatData';
import Summary from '../UserDetails/Summary';

function TableData() {
    const params = useParams()
    const userId = params.userId
    const dispatch = useDispatch();
    const [clinicalData, setClinicalData] = useState([])
    const [innerHtml, setInnerHtml] = useState([])
    const { status, data, compliance, notes, intakeCheckList } = useSelector((state) => state.user);

    useEffect(() => {
        let url = `${BASE_URL}/user/clinic`;

        fetch(url, {
            method: "POST",
            headers: {
                "authorization": `${localStorage.getItem('token')}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ "userId": userId })
        }).then((response) => response.json()).then((res) => {
            setInnerHtml(res?.clinicalHtml);

            setClinicalData(res.clinicalData)
        });

    }, [])

    return (
        <div>
            {/* <Header /> */}
            <div className='full-container'>
                <div style={{ margin: '0px 10px' }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" to="/users">
                            Users
                        </Link>
                        <Link
                            underline="hover"
                            color="inherit"
                            to={`/user_details/${params.userId}`}
                        >
                            Summary
                        </Link>
                        <Typography color="text.primary">Performance Details</Typography>
                    </Breadcrumbs>
                    {data &&<div style={{backgroundColor: "aliceblue",padding:"10px",borderRadius:'10px'}}> <Summary data={data} compliance={compliance} /></div>}
                </div>
              
                <div style={{ padding: '0px 10px', marginTop: '20px' }}>
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>

                        {clinicalData && <Basic answers={clinicalData?.answers} />}
                        <Intake answers={clinicalData?.answers} />

                        <div style={{ flexDirection: 'column' }}>
                            <Elixhauser elixhauser={clinicalData?.elixhauser} />
                            <Otherjoints otherjoints={clinicalData?.otherJoints} />
                        </div>

                    </div>

                    {/* {clinicalData?.weekly &&
                        <Monthly weekly={clinicalData?.weekly} />
                    } */}
                    <div>
                        <InnerHTMLTable
                            data={innerHtml}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TableData